import React, { useEffect } from "react";
import "./contact.css";
import Navbar from "../../components/navbar/Navbar";
import Footer from "../../components/footer/Footer";
// import LocationIcon from "../../assets/images/LocationIcon.svg";
import LocationIcon from "../../assets/images/LocationIcon";
import PhoneIcon from "../../assets/images/PhoneIcon";
import EmailIcon from "../../assets/images/EmailIcon";
import Facebook from "../../assets/images/Facebook";
import Instagram from "../../assets/images/Instagram";
import { useLocation } from "react-router-dom";
import SEO from "../../components/SEO/SEO";

const Contact = () => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);
  return (
    <div>
      <SEO
        title="Contact Us"
        description="Contact Swadaa Security & Guards Limited for security guard services, surveillance, emergency response, and community empowerment solutions in Lagos. Reach out for fast quotes and professional support."
        keywords="Swadaa Security contact, security service inquiry, Lagos security company, security guard quote, email, phone, safety services"
      />
      <Navbar />
      <div className="contactUs_sectionOneCont">
        <div className="contactUs_sectionOne_gen">
          {/* <a
            aria-label="Chat on WhatsApp"
            href="https://api.whatsapp.com/send?phone=+2348033477608&text=I%20am%20reaching%20out%20to%20explore%20your%20business%20offering."
            target="_blank"
            className="whatsappStickbody"
          >
            <div className="whatsappStickActive"></div>
            <img src={ProductImg.whatsApp} />
          </a> */}
          <div className="contact_genLeftCont">
            <div className="contact_form_header">
              <div className="contact_genLeftContHeadText">
                Get in{" "}
                <span className="contact_genLeftContHeadText_span">Touch</span>
              </div>
              <p className="contact_form_subheader">
                Have a question or want to work with us? Send us a message and
                we'll get back to you shortly.
              </p>
            </div>
            <form className="modern_contact_form">
              <div className="contact_genLeftCont_input">
                <label className="form_label">Full Name</label>
                <input
                  type="text"
                  placeholder="Enter your name"
                  className="modern_input"
                />
              </div>
              <div className="contact_genLeftCont_input">
                <label className="form_label">Email Address</label>
                <input
                  type="email"
                  placeholder="Enter your email"
                  className="modern_input"
                />
              </div>
              <div className="contact_genLeftCont_textarea">
                <label className="form_label">Your Message</label>
                <textarea
                  placeholder="Tell us how we can help..."
                  className="modern_textarea"
                  rows="5"
                />
              </div>

              <button type="submit" className="contact_genLeftCont_BtnSub">
                <span>Send Message</span>
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M18 2L9 11M18 2L12 18L9 11M18 2L2 8L9 11"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </button>
            </form>
          </div>

          <div className="contact_genRightCont">
            <div className="contact_genRightCont_">
              {/* <div className="contact_genRightCont_Img">
                <LocationIcon fill="#3c3d73" />
              </div> */}
              <div>Head Office:</div>
              <div
                className="contact_genRightCont_ImgText"
                style={{ marginBottom: "10px" }}
              >
                1, Balogun Street, Ajegunle, Ikorodu Road, Lagos.
              </div>
              <div>Regional Office:</div>
              <div className="contact_genRightCont_ImgText">
                Plot 10, Okpanam Road, Ibusa Bypass, Delta State, Nigeria.
              </div>
            </div>

            <div
              style={{ color: "#000", marginTop: "20px", fontSize: "16px" }}
              className="footerSecGen3_contD_phone"
            >
              +234 905 616 9313, +234 706 602 5588
            </div>

            {/* <div className="contact_genRightCont_">
              <div className="contact_genRightCont_Img">
                <EmailIcon fill="#3c3d73" />
              </div>
              <div className="contact_genRightCont_ImgText">
                swadaaexpress@gmail.com
              </div>
            </div> */}

            {/* <div className="contact_social_accts">
              <div className="contact_social_each">
                <Youtube fill="#3c3d73" />
              </div>

              <a
                href="https://web.facebook.com/profile.php?id=61558437594591"
                target="_blank"
                style={{ textDecoration: "none", color: "#fff" }}
                className="contact_social_each"
              >
                <Facebook fill="#3c3d73" />
              </a>

              <a
                href="https://www.instagram.com/levit7tjc/"
                target="_blank"
                style={{ textDecoration: "none", color: "#fff" }}
                className="contact_social_each"
              >
                <Instagram fill="#3c3d73" />
              </a>
              <div className="contact_social_each">
                <Twitter fill="#3c3d73" />
              </div>
            </div> */}
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Contact;
